import { Fragment } from 'react'
import Item from '../images/Item'
import styles from './BuySetCell.module.css'

const BuySetCell = ({time,set}) => {
  return (
    <div className={styles.buysetcell}>
      <div>{time}<br />min</div>
      <div>
        { typeof set.B !== 'undefined' && <div>{ Object.keys(set.B).map((item,i)=>
          <Fragment key={i}><Item key={i} id={parseInt(item)} type='item30r' /><div className={styles.count}>{ set.B[item]>1 &&set.B[item]}</div></Fragment>)}</div>}
        { typeof set.S !== 'undefined' && <div>{ Object.keys(set.S).map((item,i)=>
          <Fragment key={i}><Item id={parseInt(item)} type='item30r' /><div className={styles.sell}>x</div></Fragment>)}</div> }
      </div>
    </div>
  )
}


export default BuySetCell
